














import { Component, Prop, Vue } from "vue-property-decorator";

interface Cliente {
  nome: string;
  depoimento: string;
  foto: string;
  profissao: string;
}

const CLIENTES = [
  {
    nome: "Nilma Saar",
    profissao: "bióloga",
    foto: "/fotos/nilma.jpg",
    depoimento:
      "Quanto agradecida, Kimtara, sou pelo teu profissionalismo, tua forma de atuação e tua ética"
  },
  {
    nome: " Aline de Alcântara",
    profissao: "musicista",
    foto: "/fotos/aline.jpg",
    depoimento:
      "Acho que nunca vou conseguir expressar em palavras o que o trabalho (da Kimtara) influenciou na minha carreira. Mudou algo em mim porque eu comecei a me propor a fazer coisas diferentes, a buscar outros tipos de trabalho, a ter mais coragem de levar adiante projetos mais ousados"
  },
  {
    nome: "Malu Romancini",
    profissao: "advogada",
    foto: "/fotos/manu.jpg",
    depoimento:
      "Descobri em qual momento da vida eu me encontrava e pude ter bases para tomar decisões que precisavam ser feitas também na minha empresa. Pude entender como eu empregava todo aquele esforço na minha empresa e ela não tinha o resultado esperado por mim"
  },

  {
    nome: "Simone Ittner",
    profissao: "numeróloga",
    foto: "/fotos/simone.jpg",
    depoimento:
      "(Kimtara) foi um divisor de águas para mim porque descobri qual a minha missão de vida, meu propósito e, sabendo disso, consegui trilhar um caminho, trilhar o que minha alma já tinha definido antes de eu vir para esse mundo"
  },
  {
    nome: "Maria Cristina Yanavalin",
    profissao: "coaching master",
    foto: "/fotos/maria.jpg",
    depoimento:
      "(Ela) fez uma grande diferença na minha vida. Agregou um valor impressionante, diminuíram muitos os meus desafios e minha vida tomou um rumo completamente diferente, com a consciência do que fazer e quando fazer cada coisa"
  },

  {
    nome: "Sidneia de Liz",
    profissao: "mãe de dois filhos",
    foto: "/fotos/sidneia.jpg",
    depoimento:
      "Kimtara foi um anjo que Deus enviou na hora certa, onde eu precisava de um direcionamento, saber qual direção tomar porque até então eu não conseguia mais enxergar uma luz no fim do túnel. Eu acho que todo mundo tinha que ter uma Kimtara na vida, para ajudar mesmo"
  },
  {
    nome: "Shamdaki",
    profissao: "terapeuta",
    foto: "/fotos/shamdaki.jpg",
    depoimento:
      "(Após o contato com a Kimtara) pude ter mais clareza de quais são os meus desafios e quais são as minhas habilidades para que eu possa alcançar o que eu quero. Ela tem um jeito muito incrível de falar a respeito das nossas habilidades e nossos desafios"
  },
  {
    nome: "Frank Ribeiro",
    profissao: "profissional de Tecnologia da Informação",
    foto: "/fotos/frank.jpg",
    depoimento:
      "Ela (Kimtara) é uma profissional excelente. Acabei encontrando muitas respostas após ser atendido por ela. É realmente uma profissional para vida, uma profissional da família"
  },
  {
    nome: "Fábio Chaves",
    profissao: "empresário",
    foto: "/fotos/fabio.jpg",
    depoimento:
      "Após meu contato com a Kimtara, pude ter um norte melhor de quais atitudes tomar no meu trabalho, no âmbito familiar e no âmbito de relacionamentos, principalmente. Isso me ajudou muito a crescer e a ter uma visão melhor do mundo, do que eu vim fazer e qual o meu propósito que eu podia potencializar"
  }
];

@Component
export default class extends Vue {
  // @Prop() private msg!: string;

  clientes: Array<Cliente> = [];

  mounted() {
    this.clientes = CLIENTES;
  }
}
